export interface MockFallbackOptions {
  /** Shape validator. Return false to surface an invalid API response. */
  validate?: (value: unknown) => boolean;
  /** Label cho console.warn khi API response không hợp lệ. */
  label?: string;
}

/**
 * Compatibility wrapper for legacy callers. Mock fallback is disabled:
 * queries must use the real API and let TanStack Query expose errors/empty states.
 */
export async function withMockFallback<T>(
  realFn: () => Promise<T>,
  _mockFn: () => unknown,
  options: MockFallbackOptions = {},
): Promise<T> {
  const result = await realFn();
  if (options.validate && !options.validate(result)) {
    if (import.meta.env.DEV) {
      console.warn(`[api-response] ${options.label ?? 'query'}: invalid shape`);
    }
  }
  return result;
}

/** Validator: object có key chỉ định. */
export function hasKey(key: string): (v: unknown) => boolean {
  return (v: unknown) =>
    !!v && typeof v === 'object' && key in (v as Record<string, unknown>);
}

/** Validator: response có shape { data: array } — list pattern. */
export function isListResponse(v: unknown): boolean {
  return (
    !!v &&
    typeof v === 'object' &&
    Array.isArray((v as { data?: unknown }).data)
  );
}

/** Validator: là array. */
export function isArrayResponse(v: unknown): boolean {
  return Array.isArray(v);
}
